"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = resolveWith;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

/**
 * Sugar method for returning the desired object at the end of a promise chain
 * @param {any} object the item with which to resolve the promise chain
 * @returns {function}
 * @example
 * var item = {
 *   prop: 2
 * };
 * Promise
 *  .resolve(item.prop)
 *  .then(resolveWith(item))
 *  .then(function(res) {
 *    require('assert').deepEqual(res, {prop:2});
 *    return 'success'
 *  })
 *  // => success
 *
 */
function resolveWith(object) {
  return function resolver() {
    return _promise.default.resolve(object);
  };
}
//# sourceMappingURL=resolve-with.js.map
